import MyPage from '../../../../Commons/Layouts/MyPage';
import Container from './Container';

const Group = (props) => {
  return (
    <MyPage>
      <Container {...props} />
    </MyPage>
  );
};

export default Group;
